<template>
  <v-container fluid class="pa-0 pb-6">
    <v-card outlined class="mx-auto pa-4">
      <div class="d-flex align-center">
        <div class="primary--text font-weight-bold mb-4">
          {{ $vuetify.lang.t("$vuetify.account_settings.account_migration") }}
        </div>

        <v-tooltip bottom max-width="350">
          <template v-slot:activator="{ on }">
            <span v-on="on" class="info-icon ml-2 mb-4">i</span>
          </template>

          <span>
            {{ $vuetify.lang.t("$vuetify.account_settings.hints.revoke_session_data") }}
          </span>
        </v-tooltip>
      </div>

      <v-form ref="invoiceFormRef">
        <v-row>
          <v-col cols="12" md="6" class="pt-0">
            <v-text-field
              v-model.trim="invoiceForm.accountId"
              :label="$vuetify.lang.t('$vuetify.account_settings.account_id')"
              outlined
              :rules="[rules.required($vuetify.lang.t('$vuetify.account_settings.account_id'))]"
            />
          </v-col>

          <v-col cols="12" class="pt-0">
            <v-checkbox
              v-model="invoiceForm.isInvoiceApplicable"
              hide-details
              class="ma-0"
            >
              <template v-slot:label>
                <div class="d-flex align-center">
                  <span>
                    {{ $vuetify.lang.t("$vuetify.account_settings.retail") }}
                  </span>

                  <v-tooltip bottom max-width="350">
                    <template v-slot:activator="{ on }">
                      <span v-on="on" class="info-icon ml-2">i</span>
                    </template>

                    <span>
                      {{ $vuetify.lang.t("$vuetify.account_settings.hints.retail") }}
                    </span>
                  </v-tooltip>
                </div>
              </template>
            </v-checkbox>
          </v-col>

          <v-col cols="12" class="mt-2 d-flex justify-end">
            <v-btn
              color="primary"
              :loading="updating"
              @click="openConfirmationDialog"
            >
              {{ $vuetify.lang.t("$vuetify.common.update_btn") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-form>

      <DialogModal
        v-model="confirmationDialog"
        :title="$vuetify.lang.t('$vuetify.common.confirm_alert_title_txt')"
        :message="$vuetify.lang.t('$vuetify.account_settings.messages.account_migration_confirm_message')"
        :confirmButtonText="$vuetify.lang.t('$vuetify.common.confirm_btn')"
        :cancelButtonText="$vuetify.lang.t('$vuetify.common.cancel_btn')"
        :confirmBtnLoading="updating"
        @onConfirmation="confirmUpdate"
        @onCancel="closeConfirmationDialog"
      />
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
  UPDATE_INVOICE_FLAG,
  ADD_ALERT,
} from "@/store/_actiontypes";
import validations from "@/helpers/validations";
import DialogModal from "@/components/common/DialogModal";

export default {
  name: "AccountMigrationCard",

  components: {
    DialogModal,
  },

  data() {
    return {
      invoiceForm: {
        accountId: "",
        isInvoiceApplicable: false,
      },
      updating: false,
      confirmationDialog: false,
      invoicePayload: null,
    };
  },

  computed: {
    ...mapGetters("account", [
      "invoiceFlagSuccessMessage",
      "invoiceFlagErrorMessage",
    ]),

    rules() {
      return {
        required: (property) => validations.requiredTrimmed(property),
      };
    },
  },

  methods: {
    ...mapActions("account", {
      updateInvoiceFlagApi: UPDATE_INVOICE_FLAG,
    }),

    ...mapActions("alert", {
      addAlert: ADD_ALERT,
    }),

    openConfirmationDialog() {
      const isValid = this.$refs.invoiceFormRef.validate();
      if (!isValid) return;

      this.invoicePayload = {
        account_id: this.invoiceForm.accountId,
        is_invoice_applicable: this.invoiceForm.isInvoiceApplicable,
      };

      this.confirmationDialog = true;
    },

    closeConfirmationDialog() {
      this.confirmationDialog = false;
      this.invoicePayload = null;
    },

    async confirmUpdate() {
      if (!this.invoicePayload) return;

      this.updating = true;

      try {
        await this.updateInvoiceFlagApi(this.invoicePayload);

        this.addAlert({
          message:
            this.invoiceFlagSuccessMessage ||
            this.$vuetify.lang.t(
              "$vuetify.account_settings.messages.account_migration_update_success"
            ),
          color: "success",
        });

        this.invoiceForm = {
          accountId: "",
          isInvoiceApplicable: false,
        };

        this.$nextTick(() => {
          this.$refs.invoiceFormRef?.resetValidation();
        });
      } catch (error) {
        this.addAlert({
          message:
            this.invoiceFlagErrorMessage ||
            this.$vuetify.lang.t(
              "$vuetify.account_settings.messages.account_migration_update_failed"
            ),
          color: "error",
        });
      } finally {
        this.updating = false;
        this.closeConfirmationDialog();
      }
    },
  },
};
</script>